import script from "./DashboardSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./DashboardSkeleton.vue?vue&type=style&index=0&id=474a1c88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-474a1c88"]])

export default __exports__